/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_BOXES = gql`
  query GetBoxes($filter: BoxFilterInput) {
    getBoxes(filter: $filter) {
      content {
        costumeID
        paymentStats
        note
        user {
          userId
          email
          fullName
          lastName
          firstName
          phones {
            number
          }
        }
        delivery {
          isOpted
          partner
          status
          trackingId
        }
        presentation {
          id
          name
        }
        section {
          id
          name
        }
        items {
          costumeType {
            name
            description
            images
            minDownPayment
          }
          costumeFeature {
            id
            name
          }
          costumeAttribute {
            id
            name
          }
          costumeValue {
            id
            name
            topupPrice
            minDownPayment
          }
        }
        payOrder {
          id
          orderId
          updatedAt
          payTxes {
            id
            amount
            mode
            reciptId
            status
            txId
            createdAt
            payMethod
          }
          paymentStatus
          remainingAmount
          amountPaid
          invitedBy
        }
        boxTxes {
          action
          actionContent
          box
          createdAt
          displayTitle
          user {
            vuid
            firstName
            lastName
            email
          }
          reason
        }
        amountPaid
        totalAmount
        totalAmountInUSD
        amountPaidInUSD
        id
        isActive
      }
    }
    getCurrencyExchangeRate {
      payment_mode
      conversion_rate
      currency
      provider
    }
  }
`;
